import { useId, useState, useEffect, useMemo } from 'react';
import { TabContext } from './context.js';
import { getTabs } from './getTabs.js';
import { jsx } from 'react/jsx-runtime';

function TabProvider(props) {
  var tabGroupId = useId();
  var children = props.children,
    initialActiveTab = props.initialActiveTab,
    onSelect = props.onSelect,
    stretch = props.stretch;
  var _useState = useState(initialActiveTab),
    uncontrolledActiveTab = _useState[0],
    setUncontrolledActiveTab = _useState[1];
  var _props$activeTab = props.activeTab,
    activeTab = _props$activeTab === void 0 ? uncontrolledActiveTab : _props$activeTab;
  useEffect(function () {
    if (!activeTab && !initialActiveTab) {
      var tabs = getTabs(tabGroupId);
      setUncontrolledActiveTab(tabs[0]);
    }
  }, [activeTab, initialActiveTab, tabGroupId]);
  var context = useMemo(function () {
    var focusTab = function focusTab(id) {
      var tab = document.querySelector("[id=\"" + tabGroupId + "\"] [id=\"" + tabGroupId + "-" + id + "\"]");
      tab === null || tab === void 0 ? void 0 : tab.focus();
    };
    var setActiveTab = function setActiveTab(id) {
      if (id === undefined) {
        return;
      }
      focusTab(id);
      if (onSelect) {
        onSelect(id);
      } else {
        setUncontrolledActiveTab(id);
      }
    };
    var navigateToNextTab = function navigateToNextTab() {
      var tabs = getTabs(tabGroupId);
      var nextIndex = tabs.indexOf(activeTab || '') + 1;
      setActiveTab(tabs[nextIndex]);
    };
    var navigateToPreviousTab = function navigateToPreviousTab() {
      var tabs = getTabs(tabGroupId);
      var previousIndex = tabs.indexOf(activeTab || '') - 1;
      setActiveTab(tabs[previousIndex]);
    };
    return {
      activeTab: activeTab,
      tabGroupId: tabGroupId,
      navigateToNextTab: navigateToNextTab,
      navigateToPreviousTab: navigateToPreviousTab,
      setActiveTab: setActiveTab,
      stretch: stretch
    };
  }, [activeTab, onSelect, tabGroupId, stretch]);
  return /*#__PURE__*/jsx(TabContext.Provider, {
    value: context,
    children: children
  });
}

export { TabProvider };
